import type posthog from 'posthog-js';
import { Logger } from './logger';

type PostHog = typeof posthog;

let pausedForConsent = false;

export const pausePostHogForConsent = (instance: PostHog): void => {
  try {
    instance.stopSessionRecording();
  } catch (error) {
    Logger.warn('PostHog failed to stop session recording after consent withdrawal', {
      error: error instanceof Error ? error.message : String(error),
    });
  }
  try {
    instance.opt_out_capturing();
  } catch (error) {
    Logger.warn('PostHog failed to opt out after consent withdrawal', {
      error: error instanceof Error ? error.message : String(error),
    });
  }
  pausedForConsent = true;
};

export const requirePostHogConsentResume = (): void => {
  pausedForConsent = true;
};

export const resumePostHogAfterConsent = (instance: PostHog): void => {
  if (!pausedForConsent) {
    return;
  }
  try {
    instance.opt_in_capturing({ captureEventName: false });
  } catch (error) {
    Logger.warn('PostHog failed to opt in after analytics consent', {
      error: error instanceof Error ? error.message : String(error),
    });
  }
  try {
    instance.startSessionRecording();
  } catch (error) {
    Logger.warn('PostHog failed to restart session recording after analytics consent', {
      error: error instanceof Error ? error.message : String(error),
    });
  }
  pausedForConsent = false;
};
